// Author Lin
// Date 2021-05-25 11:48:21

import * as model from "@/model/sithMes/inventory/SithMesInventoryShipmentModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryShipment(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
